// Store module pour SpotlightSearch
const state = {
  isOpen: false,
}

const mutations = {
  SET_SPOTLIGHT_SEARCH_OPEN(state, isOpen) {
    state.isOpen = isOpen
  },
}

const actions = {
  setSpotlightSearchOpen({ commit }, isOpen) {
    commit('SET_SPOTLIGHT_SEARCH_OPEN', isOpen)
  },
  
  openSpotlightSearch({ commit }) {
    commit('SET_SPOTLIGHT_SEARCH_OPEN', true)
  },
  
  closeSpotlightSearch({ commit }) {
    commit('SET_SPOTLIGHT_SEARCH_OPEN', false)
  },
}

const getters = {
  isSpotlightOpen: (state) => state.isOpen,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
